import React from 'react';
import style from './block.module.scss';
import he from 'he';

function SinglePostHeader({ title }) {
    return <div className={style.block}>{title && <h1 className={style.title}>{he.decode(title)}</h1>}</div>;
}

export default SinglePostHeader;
